module.exports = "/img/caret-right.svg?87b6b108219c0c5ace59f5724ec089bb";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/caret-right.svg
// module id = hJvm
// module chunks = 75